import React, {useContext, useEffect, useState} from 'react';
import {authContext} from '../Context/Authentication/authContext';
import MSATab from './Components/MSATab';
import PropertyType from '../Tabs/Components/PropertyType';
import {Tabs, Tab, Box} from '@mui/material';
import {a11yProps} from '../Helpers/helpers';
import '../Tabs/Tabs.scss'

const TABS = [
  {name: 'Home sales', title: 'Home Sales'},
  {name: 'Days on market', title: 'Days On Market'},
  {name: 'Price', title: 'Price'},
  {name: 'MSP', title: 'Median Sale Price'},
  {name: 'Months of Supply', title: 'Months of Supply'},
  {name: 'Rentals', title: 'Rentals'},
  {name: 'Property Type', title: 'Property Type'},
]

const PER_TABS = ['Price', 'MSP', 'Days on market', 'Home sales', 'Months of Supply', 'Property Type']
const SHOW_COMPARISON = ["Home sales", "Days on market", "Price", "MSP"];

const MSATabs = () => {
  const {state, dispatch}: any = useContext(authContext);

  useEffect(() => {
    if (state?.filters?.msa?.length > 0) {
      handleSelectedTab((state.selectedTab && TABS.map((t: any) => t.name).includes(state.selectedTab) ? state.selectedTab : 'Home sales'));
    }
  }, [state?.filters?.msa]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    handleSelectedTab(newValue);
    dispatch({
      type: 'APPLY_FILTER',
      payload: {
        ...state.filters,
        trackEvent:'tabChange',
        showComparison:SHOW_COMPARISON.includes(newValue)?state.filters.showComparison:false
      },
    });
  }

  const handleSelectedTab = (val: string) => {
    dispatch({
      type: 'SET_TAB_SELECTION',
      payload: val,
    });
    dispatch({
      type: 'APPLY_FILTER',
      payload: {
        ...state.filters,
        trackEvent:'tabChange'
      },
    });
    if (!PER_TABS.includes(val)) {
      dispatch({
        type: 'APPLY_FILTER',
        payload: {
          ...state.filters,
          value: 'Absolute',
        },
      });
    }
  };

  return (
    <div className='tabs-main'>
      <Box className='tabs-main__menuContainer'>
        <Tabs
          value={state.selectedTab}
          onChange={handleChange}
          variant='scrollable'
          scrollButtons='auto'
          selectionFollowsFocus
          TabIndicatorProps={{
            style: {
              backgroundColor: '#fff',
            }
          }}
        >
          {TABS.map((tabItem: any, i: number) => (
              <Tab
                className='tabs-main__menuContainer__menuItem'
                value={tabItem.name}
                sx={{minWidth: 'fit-content', flex: 1}}
                label={tabItem.title}
                style={{
                  backgroundColor: state?.selectedTab === tabItem.name ? '#f7b047' : '',
                  borderRadius: state?.selectedTab === tabItem.name ? '4px' : '',
                  fontWeight: state?.selectedTab === tabItem.name ? 'bold' : 'normal',
                  color: '#fff',
                }}
                {...a11yProps(i)}
              />
            )
          )}
        </Tabs>
      </Box>
      {state?.selectedTab === 'Home sales' && <MSATab tabType={'Home sales'} dataType={'homeSales'}/>}
      {state?.selectedTab === 'Days on market' && <MSATab tabType={'Days on market'} dataType={'daysOnMarket'}/>}
      {state?.selectedTab === 'MSP' && <MSATab tabType={'MSP'} dataType={'msp'}/>}
      {state?.selectedTab === 'Price' && <MSATab tabType={'Price'} dataType={'ppsf'}/>}
      {state?.selectedTab === 'Months of Supply' && <MSATab tabType={'Months of Supply'} dataType={'mos'}/>}
      {state?.selectedTab === 'Rentals' && <MSATab tabType={'Rentals'} dataType={'rental_index'}/>}
      {state?.selectedTab === 'Property Type' && <PropertyType type={'metroarea'}/>}
    </div>
  );
};

export default React.memo(MSATabs);